import { Component, OnInit } from '@angular/core';
import type { HomeFaqItem } from 'src/app/page/home/models/home-faq-content.model';
import { HomeFaqService } from 'src/app/page/home/services/home-faq.service';
import { AnalyticsTagService } from 'src/app/services/analytics-tag.service';

@Component({
  selector: 'app-preguntas-frecuentes',
  templateUrl: './preguntas-frecuentes.component.html',
  styleUrls: ['./preguntas-frecuentes.component.scss'],
  standalone: false,
})
export class PreguntasFrecuentesComponent implements OnInit {
  items: HomeFaqItem[] = [];
  openIndex: number | null = 0;
  cargando = true;

  constructor(
    private readonly homeFaqService: HomeFaqService,
    private readonly analyticsTag: AnalyticsTagService
  ) {
    window.scroll(0, 0);
  }

  ngOnInit(): void {
    this.homeFaqService.loadContent().subscribe((content) => {
      this.items = [...content.items].sort((a, b) => a.orden - b.orden);
      this.openIndex = this.items.length ? 0 : null;
      this.cargando = false;
    });
  }

  toggleFaq(index: number): void {
    this.openIndex = this.openIndex === index ? null : index;
  }

  /** Asegura que el home se muestre desde el tope al volver. */
  scrollHomeTop(): void {
    this.analyticsTag.trackCtaClick({
      ctaLabel: 'Volver',
      ctaSection: 'faq',
      ctaComponent: 'preguntas-frecuentes',
      ctaElementId: 'btn-faq-volver',
      hu: '8335',
    });
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }
}
